export default __webpack_public_path__ + "static/media/lungs_img_0011_The_Artist.e9ad0adb.png";